import { CheckCircleIcon } from '@heroicons/react/20/solid';
import useNavigation from '../common/navigation';

export default function AccountDeletedPage() {
  const { goToHomePage } = useNavigation();

  return (
    <div className="min-h-screen bg-white flex items-center justify-center px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full text-center space-y-5">
        <CheckCircleIcon className="mx-auto h-12 w-12 text-teal-500" />
        <h2 className="mt-6 text-3xl font-bold tracking-tight text-gray-900">Account Deleted</h2>
        <p className="text-lg text-gray-800">
          Your account and all of its data has been successfully deleted.
        </p>
        <p className="text-base text-gray-500">
          We're sorry to see you go! If this was a mistake or you have feedback, feel free to
          contact us at support@notewell.ai
        </p>
        <div></div> {/* Hack for adding more spacing above button */}
        <button
          onClick={goToHomePage}
          className="inline-flex items-center justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-bold text-white shadow-sm hover:bg-indigo-700 transition"
        >
          Go to Login Page
        </button>
      </div>
    </div>
  );
}
